// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1jRZk","signatureButtonsRight":"ModalSign_signatureButtonsRight__2VKVp"};